import { useGetVacancies, type Vacancies } from '@entities/vacancy';
import { Loader, Select, type SelectProps } from '@mantine/core';
import { PaginateType } from '@shared/types';
import { IconChevronDown } from '@tabler/icons-react';

export const RecruiterSelect = ({ ...props }: SelectProps) => {
  const { data: vacancies, isLoading } = useGetVacancies({
    filter: {},
    sort: {},
    paginate: PaginateType.NONE,
  });

  const uniqueRecruiters = new Map();

  if (Array.isArray(vacancies)) {
    (vacancies as Vacancies)?.forEach(item => {
      const userId = item.responsibleUser.id.toString();
      const userName = `${item.responsibleUser.profile.firstName} ${item.responsibleUser.profile.lastName}`;

      if (!uniqueRecruiters.has(userId)) {
        uniqueRecruiters.set(userId, {
          label: userName,
          value: userId,
        });
      }
    });
  }

  return (
    <Select
      data={Array.from(uniqueRecruiters.values())}
      rightSection={
        isLoading ? (
          <Loader size='xs' />
        ) : (
          <IconChevronDown size={20} color='var(--mantine-color-primary-7)' />
        )
      }
      searchable
      {...props}
    />
  );
};
